var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"xc-loading"},[_c('div',{staticClass:"xc-loading-box"},[_c('div',{staticClass:"xc-loading-spinner xc-loading-lds-dual-ring"}),_c('div',{staticClass:"xc-loading-text"},[_vm._v(_vm._s(typeof _vm.text == 'string' ?_vm.text:'请求中……'))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }